/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BackInputs */

const en_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

const es_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atrás`)
};

const fr_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour`)
};

const de_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

const ja_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻る`)
};

const zh_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回`)
};

const ar_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رجوع`)
};

const id_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali`)
};

const it_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indietro`)
};

const ru_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

const pt_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar`)
};

const ko_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`뒤로`)
};

/**
* | output |
* | --- |
* | "Back" |
*
* @param {BackInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const back = /** @type {((inputs?: BackInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BackInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_back(inputs)
	if (locale === "es") return es_back(inputs)
	if (locale === "fr") return fr_back(inputs)
	if (locale === "de") return de_back(inputs)
	if (locale === "ja") return ja_back(inputs)
	if (locale === "zh") return zh_back(inputs)
	if (locale === "ar") return ar_back(inputs)
	if (locale === "id") return id_back(inputs)
	if (locale === "it") return it_back(inputs)
	if (locale === "ru") return ru_back(inputs)
	if (locale === "pt") return pt_back(inputs)
	return ko_back(inputs)
});